"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.company.checkbox_label': '使用公司注册',
    'register.company.form_title': '公司信息',
    'register.company.section_title': '公司信息（可选）',
    'register.company.add_button': '添加公司',
    'register.company.data_added': '公司数据添加成功',
    'register.company.remove_button': '删除公司',
    'register.company.optional_help': '您可以在注册时选择性地添加公司信息',
    'register.company.removed': '公司数据删除成功',
};
